import _filter from 'lodash/filter';

function Ctrl($scope, $rootScope, $state, $location, utilsService, loggerService, bookingHelpers, metaTagService) {
  metaTagService.set({
    title: 'Your Bookings | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.bookingsPromise.then(function success(response) {
    response = _filter(response, bookingHelpers.isTicket);

    $scope.sortedBookings = {
      all: response,
      upcoming: _filter(response, bookingHelpers.isUpcomingBooking),
      past: _filter(response, bookingHelpers.isPastBooking)
    };
  }, error);

  $scope.scrollTo = function(id) {
    utilsService.scrollTo(id);
  };

  function error(response) {
    $scope.errorMsg = utilsService.errorMessage(response);
    loggerService.error(response);
  }
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$state',
  '$location',
  'utilsService',
  'loggerService',
  'bookingHelpersService',
  'metaTagService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/accountTickets/accountTicketsCtrl.js